import { CourseListFilters } from "../../generated/graphql"

// AKTIVE-FILTER-LOGIK ------------------------------------------------------------------------------------------
// Gemeinsam genutzt von CourseFilters (Badge/Chips) und CoursesTable (Sichtbarkeit
// der Interessenten-Zeilen). Kernidee: die iFrame-/Web-Modul-Konfiguration ist die
// BASELINE, kein Nutzerfilter — nur Abweichungen davon zählen als "aktiv gesetzt".

// Nur diese benutzerseitigen Felder zählen für Badge/Chips.
export const ACTIVE_FILTER_FIELDS: Array<keyof CourseListFilters> = [
    "courseTypeId",
    "instructorId",
    "city",
    "locationId",
    "dayFilter",
    "monthFilter",
    "courseCategoryId",
]

// Inhaltsfilter, die darüber entscheiden, ob eine Suche stattgefunden hat
// (Kursart/Ort/Stadt/Wochentag). Bewusst OHNE instructorId/monthFilter/Kategorie:
// identisch zur bisherigen Feldmenge in CoursesTable.
export const CONTENT_FILTER_FIELDS: Array<keyof CourseListFilters> = ["courseTypeId", "courseTypeIds", "locationId", "city", "dayFilter"]

// Leerer Wert = inaktiv. WICHTIG: ein leeres Array (dayFilter=[]/monthFilter=[])
// muss als inaktiv gelten (sonst zählt getFilterIsActiveClass es fälschlich als aktiv).
export const isEmptyFilterValue = (value: unknown) =>
    value === null || value === undefined || value === "" || (Array.isArray(value) && value.length === 0)

// Set-Gleichheit für Array-Felder, sonst strikter Vergleich.
export const areFilterValuesEqual = (a: unknown, b: unknown) => {
    if (Array.isArray(a) || Array.isArray(b)) {
        const aa = Array.isArray(a) ? a : a === null || a === undefined ? [] : [a]
        const bb = Array.isArray(b) ? b : b === null || b === undefined ? [] : [b]
        if (aa.length !== bb.length) return false
        const sa = aa.map(String).sort()
        const sb = bb.map(String).sort()
        return sa.every((x, i) => x === sb[i])
    }
    return a === b
}

// Ein Feld ist "vom Nutzer aktiv gesetzt", wenn es nicht leer ist UND sich von der
// iFrame-Baseline unterscheidet. So zählen iFrame-fixierte Vorgaben (z.B. ein
// vorgegebener locationId) weder im Badge noch als entfernbarer Chip.
export const getActiveFilterFields = (
    filters: CourseListFilters,
    baseline: CourseListFilters,
    fields: Array<keyof CourseListFilters> = ACTIVE_FILTER_FIELDS
): Array<keyof CourseListFilters> =>
    fields.filter((field) => {
        const value = filters?.[field]
        if (isEmptyFilterValue(value)) return false
        return !areFilterValuesEqual(value, baseline?.[field])
    })
